window.addEventListener('load', () => {
  const ReactRailsUJS = require('react_ujs')
  const context = require.context('Pods', true, /\/Coupons\/(?!.*(?:test|story).*$).*$/)

  ReactRailsUJS.useContext(context)
  ReactRailsUJS.mountComponents('#fast-coupons-elements')
})
